export default __webpack_public_path__ + "static/adhdpro-2-4fc054ffcb189d8085e7f2c061efd268.png";